import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './reducer'
import * as state from './state'

export const adjustmentState = createFeatureSelector<state.State>('channelAdjustment')

export const selectAllChannelAdjustments = createSelector(adjustmentState, reducer.selectAll)

export const selectChannelAdjustmentsLoaded = createSelector(adjustmentState, (state: state.State) => state.isLoaded)
